import { useState } from 'react';

export const FieldNameDescriptor = {
  '.google.protobuf.Struct': 'MESSAGE',
};
export const styleNoUpperCase = { '> div': { textTransform: 'initial' } };

export const permissionArrayToTree = (permissions: string[]) =>
  [
    ...permissions,
    ...(permissions.includes('BACKOFFICE:UPDATE') ? ['BACKOFFICE:READ', 'BACKOFFICE:CREATE', 'BACKOFFICE:DELETE'] : []),
  ].reduce((acc, permission) => {
    const parts = permission.split(':');
    const [entity, action] = parts.slice(-2);

    return parts.length === 2
      ? { ...acc, [entity]: { ...(acc[entity] || {}), [action]: true } }
      : {
          ...acc,
          [parts[0]]: {
            ...(acc[parts[0]] || {}),
            [entity]: { ...(acc[parts[0]]?.[entity] || {}), [action]: true },
          },
        };
  }, {});

export const useForceRender = () => {
  const updateState = useState<Date>()[1];
  return () => updateState(new Date());
};
